var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEaseInLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.208496,
    y: 0.484924,
    width: 50,
    height: 50,
    rx: 25,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3256 25.2299C36.2306 24.0269 37.4936 21.9029 37.4936 19.4849C37.4366 12.6479 28.5686 10.1789 24.9536 15.8579C23.7506 13.9529 21.6266 12.6899 19.2086 12.6899C12.3716 12.7469 9.90257 21.6149 15.5816 25.2299C13.6766 26.4329 12.4136 28.5569 12.4136 30.9749C12.4706 37.8119 21.3386 40.2809 24.9536 34.6019C26.1566 36.5069 28.2806 37.7699 30.6986 37.7699C37.5356 37.7129 40.0046 28.8449 34.3256 25.2299ZM24.9536 27.3479C24.4136 26.4929 23.6876 25.7699 22.8356 25.2299C23.6906 24.6899 24.4136 23.9639 24.9536 23.1119C25.4936 23.9669 26.2196 24.6899 27.0716 25.2299C26.2166 25.7699 25.4936 26.4959 24.9536 27.3479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEaseInLife);
export default __webpack_public_path__ + "static/media/ic_ease_in_life.5b7b7794d30dd6923ffcd4ae16971481.svg";
export { ForwardRef as ReactComponent };